// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CERK","left":"styles_left__1I2gt"};